<template>
  <el-dialog append-to-body :title="title" :visible.sync="dialogFormVisible" :width="imageWidth + 'px'" @close="close">
    <el-form ref="form">
      <el-form-item>
        <img width="100%" :src="image" />
      </el-form-item>
    </el-form>
    <!-- <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="confirm">确 定</el-button>
      </div> -->
  </el-dialog>
</template>

<script>
  export default {
    name: 'ImageShow',
    data() {
      return {
        image: '',
        title: '',
        imageWidth: 600,
        dialogFormVisible: false,
      }
    },
    created() {},
    methods: {
      show(url, title) {
        this.imageWidth = 600
        this.title = title
        this.image = url
        this.getImageWidth(url);
        this.dialogFormVisible = true
      },

      getImageWidth(url)
      {
          var img = new Image();
          img.src = url;      
          var _this=this; 
          img.onload = function() {
          
              var tempWidth = img.width;
              if(tempWidth>600)
              {
                 _this.imageWidth = tempWidth;
              }
              if(tempWidth>1200)
              {
                _this.imageWidth = 1200
              }
          }
      },

      close() {
        this.$refs['form'].resetFields()
        this.form = this.$options.data().form
        this.dialogFormVisible = false
      },
    },
  }
</script>



// WEBPACK FOOTER //
// ImageShow.vue?024ecc2f